import { render, staticRenderFns } from "./PacketsInventoryProcess.vue?vue&type=template&id=7ce74dde"
import script from "./PacketsInventoryProcess.vue?vue&type=script&lang=js"
export * from "./PacketsInventoryProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports